import React, { useEffect } from "react";
import { useState, useRef } from "react";
import "./BlogCategory.css";
import LpForm from "../../packageDetailsPage/LpForm";
import moment from "moment";
import "./Blogs.css";
import Blog from "./Blog.js";
import { BsArrowRight } from "react-icons/bs";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import NewHeader from "../../../components/NewHeader/NewHeader";
import { blogsAction } from "../../../Redux/Actions";
//importing CARASOUL
import "react-multi-carousel/lib/styles.css";
import { useLocation } from "react-router-dom";
import { Scroll } from "../../../components/Scroll function/scroll";
import BLogBannner from "../../../Assets/blogListBanner.jpeg";
import {
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaFacebookF,
} from "react-icons/fa";

//import loadable from "@loadable/component";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Loader from "../../../components/Loader/Loader";
import Loadable from "react-loadable";

import Modal from "react-responsive-modal";
import Popup from "../../../components/PopupNotification/Popup";

/* Lazy load components starts */

const NewHeader = Loadable({
  loader: () => import("../../../components/NewHeader/NewHeader"),
  loading: Loader,
});

const TopNav = Loadable({
  loader: () => import("../../../components/TopNav/TopNav"),
  loading: Loader,
});

const Header = Loadable({
  loader: () => import("../../../components/Header/Header"),
  loading: Loader,
});

const Footer = Loadable({
  loader: () => import("../../../components/Footer/Footer"),
  loading: Loader,
});

const SimpleForm = Loadable({
  loader: () => import("../../../components/chatbot/SimpleForm"),
  loading: Loader,
});

const ScrolltoTop = Loadable({
  loader: () => import("../../../components/Scrolltotop/ScrolltoTop"),
  loading: Loader,
});

function BlogCategory() {
  const [Feature, setFeature] = useState(true);
  const [Latest, setLatest] = useState(false);
  const [numBlogView, setNumBlogView] = useState(3);
  const [ArticleBlogView, setArticleBlogView] = useState(2);
  const [MoreArticleButton, setMoreArticleButton] = useState(false);
  const [LessArticleButton, setLessArticleButton] = useState(true);
  const [seeMoreButton, setSeeMoreButton] = useState(false);
  const [seeLessButton, setSeeLessButton] = useState(true);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const blogdata = useSelector((state) => state.blogslist);
  const citySelected = useSelector((state) => state.cityOnTopNav);
  // const {blogpackages} = blogdata

  // const data = blogdata.blogs
  const { blogs, loading } = blogdata;
  // console.log("blog data", blogs);

  const dispatch = useDispatch();
  const location = useLocation();
  const scroll_ref = useRef(null);

  useEffect(() => {
    dispatch(blogsAction());
  }, []);

  const FeaturedBlog = () => {
    setFeature(true);
    setLatest(false);
  };
  const LatestStories = () => {
    setFeature(false);
    setLatest(true);
  };

  useEffect(() => {
    Scroll();
  }, []);
  var RecomArticles = [
    {
      id: 1,
      date: "06 Aug 2021",
      title: "Water is the key ",
    },
    {
      id: 2,
      date: "06 Aug 2021",
      title: "Water is the key ",
    },
    {
      id: 3,
      date: "06 Aug 2021",
      title: "Water is the key ",
    },
  ];

  console.log(blogs?.results?.length, ArticleBlogView);

  useEffect(() => {
    window.location.href = "https://redcliffelabs.com/myhealth/";
  });

  useEffect(() => {
    if (blogs?.results?.length - 1 == numBlogView) {
      setSeeMoreButton(true);
      setSeeLessButton(false);
    }
  }, [numBlogView]);

  useEffect(() => {
    if (numBlogView == 3) {
      // setSeeMoreButton(true)
      setSeeLessButton(true);
      setSeeMoreButton(false);
    }
  }, [numBlogView]);

  useEffect(() => {
    if (numBlogView == 3) {
      // setSeeMoreButton(true)
      setSeeMoreButton(true);
      setSeeLessButton(false);
    }
    if (blogs?.results?.length <= numBlogView) {
      setSeeMoreButton(false);
      setSeeLessButton(true);
    }
  }, [numBlogView]);

  useEffect(() => {
    if (ArticleBlogView == 2) {
      // setSeeMoreButton(true)
      setMoreArticleButton(true);
      setLessArticleButton(false);
    }
    if (blogs?.results?.length <= ArticleBlogView) {
      setMoreArticleButton(false);
      setLessArticleButton(true);
    }
  }, [ArticleBlogView]);

  useEffect(() => {
    setTimeout(() => {
      onOpenModal();
    }, 30000);
  }, []);

  return (
    <>
      <NewHeader />
      <div className="FinalDiv">
        <div className="BlogCategoryMainDiv">
          <div className="BlogCategorydiv">
            <div className="h1StyleOfBlog">
              <h1>Blogs </h1>
            </div>
            <div className="TypesOfBlog">
              <p
                className={
                  Feature ? "TypesOfBlogpara fontColor" : "TypesOfBlogpara"
                }
                onClick={FeaturedBlog}
              >
                Featured Articles
              </p>
              <p
                className={
                  Latest ? "TypesOfBlogpara fontColor" : "TypesOfBlogpara"
                }
                onClick={LatestStories}
              >
                Latest Stories{" "}
              </p>
            </div>

            <div>
              {/* <Content title="Blogs" Ispackage={false} isBlog={true} /> */}
              {Feature ? (
                <div className="BlogsDiv_of_BlogCateogry blogCatNew">
                  {blogs?.results?.map((values, index) => {
                    if (index <= numBlogView) {
                      return (
                        <div className="Blog" key={values.id}>
                          <div className="Blog__card">
                            <div className="Blog__img">
                              <LazyLoadImage
                                src={values.image}
                                alt={values.image}
                                delayTime="100"
                              />
                            </div>
                            <div className="Blog__bottom Blog__bottomMb">
                              <div className="Blog__title">
                                <Link
                                  className="Blog__title"
                                  to={`/blog/${values.slug}`}
                                >
                                  {values.blog_name}
                                </Link>
                              </div>
                              <div className="Blog__subHeader">
                                <span>{values.author_name}&nbsp;</span>
                                <span>
                                  {moment(values.created_at).format(
                                    "Do MMM  YYYY"
                                  )}
                                </span>
                              </div>
                              <div className="Blog__desc">
                                {values.description.length < 80
                                  ? values.description
                                  : `${values.description.substring(0, 60)}...`}
                              </div>
                              <div className="Blog__footer">
                                <Link to={`/blog/${values.slug}`}>
                                  Read more
                                </Link>
                                <BsArrowRight />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              ) : null}
              {Latest ? (
                <div className="BlogsDiv_of_BlogCateogry blogCatNew">
                  {blogs?.results?.map((values, index) => {
                    if (index <= numBlogView) {
                      return (
                        <div className="Blog" key={values.id}>
                          <div className="Blog__card">
                            <div className="Blog__img">
                              <LazyLoadImage
                                src={values.image}
                                alt={values.image}
                                delayTime="100"
                              />
                            </div>
                            <div className="Blog__bottom Blog__bottomMb">
                              <div className="Blog__title">
                                <Link
                                  className="Blog__title"
                                  to={`/blog/${values.slug}`}
                                >
                                  {values.blog_name}
                                </Link>
                              </div>
                              <div className="Blog__subHeader">
                                <span>{values.author_name}&nbsp;</span>
                                <span>
                                  {moment(values.created_at).format(
                                    "Do MMM  YYYY"
                                  )}
                                </span>
                              </div>
                              <div className="Blog__desc">
                                {values.description.length < 80
                                  ? values.description
                                  : `${values.description.substring(0, 60)}...`}
                              </div>
                              <div className="Blog__footer">
                                <Link to={`/blog/${values.slug}`}>
                                  Read more
                                </Link>
                                <BsArrowRight />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              ) : null}
            </div>
            <div ref={scroll_ref} className="scrollDiv"></div>
            <div className="SeeMoreDiv">
              <button
                hidden={seeLessButton}
                onClick={() => {
                  setNumBlogView(numBlogView + 4);
                }}
                type="button"
                className="SeeMore"
              >
                See more
              </button>
              <button
                hidden={seeMoreButton}
                onClick={() => {
                  setNumBlogView(numBlogView - 4);
                  scroll_ref.current.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                  });
                }}
                type="button"
                className="SeeMore"
              >
                See less
              </button>
            </div>
          </div>
          <div className="BlogSection2">
            <div className="Div__1">
              <Link
                to={`smart-full-body-checkup${
                  citySelected?.citySelect
                    ? `-${citySelected?.citySelect
                        .toLowerCase()
                        .replace(" ", "-")}`
                    : ""
                }`}
                style={{ cursor: "pointer", width: "100%" }}
              >
                <div>
                  <span>Health Check-ups Starts at</span>
                  <h2>Rs. 699/-</h2>
                </div>
                <span>Book Consultation</span>
              </Link>
            </div>
            <div className="Div__2">
              <LpForm
                butname={"SUBMIT"}
                title={"Book Your Test"}
                position={"Banner"}
                autoFill={true}
              />
            </div>
            <div className="Div__3">
              <div className="Recom_heading">
                <h2> Recommended Articles</h2>
              </div>
              {blogs &&
                blogs.results &&
                blogs.results.map((values, index) => {
                  if (index <= ArticleBlogView) {
                    return (
                      <div className="RecomDiv" key={values.id}>
                        <div className="Recom_img">
                          {" "}
                          <LazyLoadImage
                            src={values.image}
                            alt={values.image}
                            delayTime="100"
                          />
                        </div>
                        <div className="Recom_desc">
                          <p className="Recom_date">
                            {moment(values.created_at).format("Do MMM  YYYY")}
                          </p>
                          <p className="Recom_title">
                            {" "}
                            <Link
                              className="Blog__title"
                              to={`/blog/${values.slug}`}
                            >
                              {values.blog_name}
                            </Link>
                          </p>
                          <div className="Recom_readmore">
                            <Link to={`/blog/${values.slug}`}>Read more</Link>
                            <BsArrowRight strokeWidth="1px" />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}

              <button
                hidden={LessArticleButton}
                onClick={() => {
                  setArticleBlogView(ArticleBlogView + 3);
                }}
                type="button"
                className="SeeMoreArticle"
              >
                See More Article
              </button>
              <button
                hidden={MoreArticleButton}
                onClick={() => {
                  setArticleBlogView(ArticleBlogView - 3);
                }}
                type="button"
                className="SeeMoreArticle"
              >
                See Less Article
              </button>
            </div>
            <div className="Div__4">
              <h2> Follow Us On</h2>
              <div className="socialIcons">
                <a
                  target="_blank"
                  href="https://www.instagram.com/redcliffelabs/"
                >
                  {" "}
                  <FaInstagram
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />{" "}
                </a>
                <a
                  target="_blank"
                  href="https://www.facebook.com/RedcliffeLabs/"
                >
                  {" "}
                  <FaFacebookF
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />
                </a>
                <a target="_blank" href="https://twitter.com/redcliffelab">
                  {" "}
                  <FaTwitter fontSize="2.5rem" className="social_icon_design" />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/redcliffe-labs/"
                >
                  {" "}
                  <FaLinkedinIn
                    fontSize="2.5rem"
                    className="social_icon_design"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.youtube.com/c/RedcliffeLabs"
                >
                  {" "}
                  <FaYoutube fontSize="2.5rem" className="social_icon_design" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="chatbot">
          <SimpleForm />
        </div>

        {/* Notification popup */}
        <Modal
          classNames={{
            overlay: "customOverlay",
            modal: "notificationPopup_modal",
          }}
          open={open}
          onClose={onCloseModal}
          center
        >
          <Popup setOpen={setOpen} />
        </Modal>

        <ScrolltoTop />
        <Footer />
      </div>
    </>
  );
}
export default {
  component: BlogCategory,
};
